import { observer } from 'mobx-react-lite';
import { isWaitingLottieLayout } from '../../utils';
import { BrandWaitingApprovalState } from './BrandWaitingApprovalState';
import { LottieWaitingApprovalState } from './LottieWaitingApprovalState';
import { useWaitingApprovalViewModel } from './useWaitingApprovalViewModel';

type WaitingApprovalStateProps = {
    isJoinRejected?: boolean;
    onRetry: () => void;
    onDismiss?: () => void;
};

/**
 * Waiting / reject UI: общая логика в useWaitingApprovalViewModel,
 * вёрстка — lottie (стикеры) vs brand (логотип + модалка).
 */
export const WaitingApprovalState = observer((props: WaitingApprovalStateProps) => {
    const viewModel = useWaitingApprovalViewModel(props);

    if (isWaitingLottieLayout) {
        return <LottieWaitingApprovalState viewModel={viewModel} />;
    }

    return <BrandWaitingApprovalState viewModel={viewModel} />;
});
